import type { BrandConfig } from './types'
import { jppaBrand } from './jppa'
import { proaxivBrand } from './proaxiv'
import { triplomssBrand } from './triploms'

const brands: BrandConfig[] = [jppaBrand, proaxivBrand, triplomssBrand]

/** Extract the registrable root domain (last two labels) from a hostname. */
function rootDomain(hostname: string): string {
  const parts = hostname.split('.')
  return parts.slice(-2).join('.')
}

/** True when any DNS label is exactly `jppa` (prod + staging nested hosts). */
function isJppaHostname(hostname: string): boolean {
  return hostname
    .toLowerCase()
    .split('.')
    .some((label) => label === 'jppa')
}

/**
 * Detect the active brand from the current hostname.
 *
 * JPPA hosts are nested under triploms.com (e.g. app.jppa.triploms.com,
 * app.jppa.staging.triploms.com), so they must be matched by DNS label before
 * the Triplo root-domain rule. Other brands match by root domain so staging
 * subdomains (e.g. app.staging.triploms.com) resolve correctly. Falls back to
 * Triploms for any unrecognised host, including localhost during development.
 */
export function detectBrand(): BrandConfig {
  const hostname = window.location.hostname
  if (isJppaHostname(hostname)) {
    return jppaBrand
  }
  const matched = brands.find((b) => {
    if (b === jppaBrand) return false
    const root = rootDomain(b.hostname)
    return hostname === root || hostname.endsWith('.' + root)
  })
  return matched ?? triplomssBrand
}
